/*
 * Delete-product.ts
 * Description: Includes the declaration
 * of the function for deleting a product
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Delete a product
 *
 * @return {Object} Promise - updated products
 * @param {String} slug - id of a restaurant
 * @param {Number} productId - id of the product to be deleted
 */
export function deleteProduct(slug: string, productId: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/products/' + productId,
            method: 'delete',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
